__turbopack_context__.v({
  "J": "style-module-scss-module__zu5atq__J",
  "U": "style-module-scss-module__zu5atq__U",
  "activeLetter": "style-module-scss-module__zu5atq__activeLetter",
  "bold": "style-module-scss-module__zu5atq__bold",
  "component": "style-module-scss-module__zu5atq__component",
  "content-container": "style-module-scss-module__zu5atq__content-container",
  "down-arrow": "style-module-scss-module__zu5atq__down-arrow",
  "down-arrow-container": "style-module-scss-module__zu5atq__down-arrow-container",
  "hero-quote-container": "style-module-scss-module__zu5atq__hero-quote-container",
  "jumpInfinite": "style-module-scss-module__zu5atq__jumpInfinite",
  "slideDownUp": "style-module-scss-module__zu5atq__slideDownUp",
  "video-container": "style-module-scss-module__zu5atq__video-container",
  "visible": "style-module-scss-module__zu5atq__visible",
});
